import { stats } from "@/mocks/movies";

export default function StatsSection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {stats.map((s) => (
          <div
            key={s.label}
            className="rounded-xl bg-background-100 border border-background-200 p-5 md:p-6"
          >
            <p className="font-heading text-2xl md:text-4xl font-bold text-accent-600">
              {s.value}
            </p>
            <p className="mt-2 text-sm font-semibold text-foreground-900">{s.label}</p>
            <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}